module.exports = __webpack_public_path__ + "static/media/performanceEngine.e4b01fa7.jpeg";